import React, { useEffect, useState } from 'react';
import { Redirect, useParams, useLocation } from 'react-router-dom';
import { useCurrentOrgFprint } from '~/src/entities/user/hooks';
import LoadingOverlay from '../PageLayout/LoadingOverlay';
import documentsService from '~/src/services/api/documentsService';

interface RegenerateDocumentRedirectParams {
  documentId: string;
}

const RegenerateDocumentRedirect: React.FC = () => {
  const { documentId } = useParams<RegenerateDocumentRedirectParams>();
  const location = useLocation();
  const [projectId, setProjectId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const orgFprint = useCurrentOrgFprint();

  useEffect(() => {
    const fetchDocumentAndRedirect = async () => {
      try {
        setIsLoading(true);

        const response = await documentsService.getDocumentV2(
          orgFprint,
          documentId,
        );

        const projectId = response.project;
        if (projectId !== null && projectId !== undefined) {
          setProjectId(projectId);
        } else {
          setHasError(true);
        }
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (documentId && orgFprint) {
      fetchDocumentAndRedirect();
    }
  }, [documentId, orgFprint]);

  if (isLoading) {
    return <LoadingOverlay title="Loading details" subtitle="Please wait" />;
  }

  if (hasError || projectId === null || projectId === undefined) {
    return (
      <div className="mt-4 ml-4">
        <p>Error</p>
      </div>
    );
  }

  // Redirect to the populate page with the project ID
  return (
    <Redirect
      to={{
        pathname: `/populate/${projectId}`,
        search: location.search,
      }}
    />
  );
};

export default RegenerateDocumentRedirect;
